import useSWR from 'swr';

import { BonusProgramConfig } from '~/data/rewarding/types';
import { fetchFromOldApi } from '~/services/Http';

export const getBonusProgramsData = (
  employeeId: number | string,
  employmentId: number | string,
): Promise<BonusProgramConfig[]> => {
  return fetchFromOldApi(
    `/json/employee/${employeeId}/employment/${employmentId}/incentiveshort`,
  ).then((r) => r.json());
};

type PropsType = {
  employeeId: number;
  employmentId: number | string;
};
export const useGetBonusProgramsData = (props: PropsType) => {
  const { employeeId, employmentId } = props;

  const { data, isLoading, error } = useSWR(
    ['bonusProgramsData', employeeId, employmentId],
    () => getBonusProgramsData(employeeId, employmentId),
  );

  return {
    data: data || [],
    isLoading,
    error,
  };
};
